import { render, staticRenderFns } from "./KpiSecondaryCard.vue?vue&type=template&id=fae365c0&scoped=true"
import script from "./KpiSecondaryCard.vue?vue&type=script&lang=js"
export * from "./KpiSecondaryCard.vue?vue&type=script&lang=js"
import style0 from "./KpiSecondaryCard.vue?vue&type=style&index=0&id=fae365c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fae365c0",
  null
  
)

export default component.exports